"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertPillarsToItems = exports.pageQuery = void 0;
require("core-js/modules/es6.object.assign");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.array.sort");
require("core-js/modules/es6.function.name");
/*
 * Note: This section was once called "Events and Journeys".
 * It is still called this in Contentful because renaming the content type could be disruptive.
 * So when you see references to things like EventsJourneysArticleQuery, that's why.
 */
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const atoms_1 = require("@components/atoms");
const molecules_1 = require("@components/molecules");
const organisms_1 = require("@components/organisms");
const _utils_1 = require("@utils");
const _layouts_1 = require("@layouts");
// Component
var ExperienceTemplate = function ExperienceTemplate(_ref) {
    var _eventsAndJourneysCat, _heroImage$file, _socialSharingImage$f, _socialSharingImage$f2, _heroImage$file2, _articleBody$childMar, _cta$ctaBody, _cta$ctaBody$childMar;
    var slug = _ref.slug, title = _ref.title, subtitle = _ref.subtitle, eventDate = _ref.eventDate, duration = _ref.duration, experienceHost = _ref.experienceHost, heroImage = _ref.heroImage, heroImageCredit = _ref.heroImageCredit, articleBody = _ref.articleBody, cta = _ref.cta, socialSharingTitle = _ref.socialSharingTitle, socialSharingDescription = _ref.socialSharingDescription, socialSharingImage = _ref.socialSharingImage, eventsAndJourneysCategories = _ref.eventsAndJourneysCategories, priorPillars = _ref.priorPillars, allContentfulEventsAndJourneysCategory = _ref.allContentfulEventsAndJourneysCategory, allContentfulEventsAndJourneys = _ref.allContentfulEventsAndJourneys;
    var mainCategory = eventsAndJourneysCategories === null || eventsAndJourneysCategories === void 0 ? void 0 : (_eventsAndJourneysCat = eventsAndJourneysCategories[0]) === null || _eventsAndJourneysCat === void 0 ? void 0 : _eventsAndJourneysCat.name;
    var categoryLinks = [{
            label: 'all',
            to: "/experiences"
        }];
    allContentfulEventsAndJourneysCategory.edges.filter(function (_ref2) {
        var node = _ref2.node;
        return typeof node.name === 'string';
    }).map(function (_ref3) {
        var _eventsAndJourneysCat2;
        var node = _ref3.node;
        if (node === null || node.slug === 'announcement')
            return null;
        categoryLinks.push({
            label: node.name,
            to: "/experiences#" + node.slug,
            active: (eventsAndJourneysCategories === null || eventsAndJourneysCategories === void 0 ? void 0 : (_eventsAndJourneysCat2 = eventsAndJourneysCategories[0]) === null || _eventsAndJourneysCat2 === void 0 ? void 0 : _eventsAndJourneysCat2.slug) == node.slug
        });
    });
    var subHeaderTools = /*#__PURE__*/ react_1.default.createElement(molecules_1.SubHeaderTools, null, /*#__PURE__*/ react_1.default.createElement(organisms_1.Bookmarker, {
        type: "experience",
        link: process.env.GATSBY_SITE_BASE_URL + "/experiences/" + slug,
        imageUrl: heroImage === null || heroImage === void 0 ? void 0 : (_heroImage$file = heroImage.file) === null || _heroImage$file === void 0 ? void 0 : _heroImage$file.url,
        metadata: {
            title: title === null || title === void 0 ? void 0 : title.title,
            description: socialSharingDescription === null || socialSharingDescription === void 0 ? void 0 : socialSharingDescription.socialSharingDescription,
            categories: [mainCategory],
            tags: []
        }
    }), /*#__PURE__*/ react_1.default.createElement(molecules_1.SocialSharingMenu, {
        title: socialSharingTitle || (title === null || title === void 0 ? void 0 : title.title),
        description: socialSharingDescription === null || socialSharingDescription === void 0 ? void 0 : socialSharingDescription.socialSharingDescription,
        imageUrl: socialSharingImage === null || socialSharingImage === void 0 ? void 0 : (_socialSharingImage$f = socialSharingImage.file) === null || _socialSharingImage$f === void 0 ? void 0 : _socialSharingImage$f.url
    }));
    var subHeaderContent = /*#__PURE__*/ react_1.default.createElement(react_1.default.Fragment, null, subHeaderTools, /*#__PURE__*/ react_1.default.createElement(molecules_1.ShiftingSubheader, {
        shiftWaypointSelector: "#topOfArticle",
        shiftOffset: -350,
        unshiftWaypointSelector: "#bottomOfArticle",
        unshiftOffset: -200
    }, /*#__PURE__*/ react_1.default.createElement(molecules_1.QuickLinksBar, {
        links: categoryLinks,
        toolCount: _utils_1.componentChildCount(subHeaderTools)
    }), /*#__PURE__*/ react_1.default.createElement(atoms_1.ArticleProgress, null, socialSharingTitle || (title === null || title === void 0 ? void 0 : title.title))));
    var calcTeaserLayout = function calcTeaserLayout(index) {
        if (index === 0 || index % 5 === 0)
            return 'center';
        if (index % 2)
            return 'overlap';
    }; // Note: we are pulling _all_ Experiences from Contentful, not very efficient…
    var randomArticles = allContentfulEventsAndJourneys.edges.filter(function (_ref4) {
        var _node$title;
        var node = _ref4.node;
        return node.slug !== slug && !_utils_1.checkPlaceholderContent(node === null || node === void 0 ? void 0 : (_node$title = node.title) === null || _node$title === void 0 ? void 0 : _node$title.title);
    }).sort(function () {
        return 0.5 - Math.random();
    }).slice(0, 3);
    return /*#__PURE__*/ react_1.default.createElement(_layouts_1.Layout, {
        subHeaderContent: subHeaderContent
    }, /*#__PURE__*/ react_1.default.createElement(atoms_1.SeoTags, {
        title: (title === null || title === void 0 ? void 0 : title.title) + " \u2014\xA0PRIOR",
        description: socialSharingDescription === null || socialSharingDescription === void 0 ? void 0 : socialSharingDescription.socialSharingDescription,
        imageUrl: "http:" + (socialSharingImage === null || socialSharingImage === void 0 ? void 0 : (_socialSharingImage$f2 = socialSharingImage.file) === null || _socialSharingImage$f2 === void 0 ? void 0 : _socialSharingImage$f2.url),
        urlPath: "/experiences/" + slug,
        ogTitle: socialSharingTitle || (title === null || title === void 0 ? void 0 : title.title)
    }), /*#__PURE__*/ react_1.default.createElement(Article, null, /*#__PURE__*/ react_1.default.createElement(molecules_1.ArticleHeader, {
        title: title === null || title === void 0 ? void 0 : title.title,
        subtitle: subtitle === null || subtitle === void 0 ? void 0 : subtitle.subtitle,
        heroImage: heroImage === null || heroImage === void 0 ? void 0 : (_heroImage$file2 = heroImage.file) === null || _heroImage$file2 === void 0 ? void 0 : _heroImage$file2.url,
        category: mainCategory,
        categoryLink: "/experiences/#" + (mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.replace(/ /g, '-').toLowerCase()),
        heroImageCredit: heroImageCredit,
        eventDate: eventDate,
        duration: duration,
        hostedBy: experienceHost === null || experienceHost === void 0 ? void 0 : experienceHost.name
    }), /*#__PURE__*/ react_1.default.createElement(atoms_1.ArticleBody, {
        articleBody: articleBody === null || articleBody === void 0 ? void 0 : (_articleBody$childMar = articleBody.childMarkdownRemark) === null || _articleBody$childMar === void 0 ? void 0 : _articleBody$childMar.html,
        id: "topOfArticle"
    }), priorPillars && /*#__PURE__*/ react_1.default.createElement(molecules_1.ImageAndCopyGrid, {
        title: "Trip Highlights",
        items: exports.convertPillarsToItems({
            priorPillars: priorPillars
        })
    }), /*#__PURE__*/ react_1.default.createElement("div", {
        id: "bottomOfArticle"
    }), cta && /*#__PURE__*/ react_1.default.createElement(organisms_1.CtaForm, {
        titleIntro: cta === null || cta === void 0 ? void 0 : cta.ctaIntro,
        title: title === null || title === void 0 ? void 0 : title.title,
        description: cta === null || cta === void 0 ? void 0 : (_cta$ctaBody = cta.ctaBody) === null || _cta$ctaBody === void 0 ? void 0 : (_cta$ctaBody$childMar = _cta$ctaBody.childMarkdownRemark) === null || _cta$ctaBody$childMar === void 0 ? void 0 : _cta$ctaBody$childMar.html,
        subject: title === null || title === void 0 ? void 0 : title.title
    })), /*#__PURE__*/ react_1.default.createElement(atoms_1.Button, {
        to: "/experiences",
        type: "outline",
        lines: true,
        center: true,
        size: "large"
    }, "More Experiences"), /*#__PURE__*/ react_1.default.createElement(TeaserList, null, randomArticles === null || randomArticles === void 0 ? void 0 : randomArticles.map(function (_ref5, index) {
        var _node$title2, _node$eventsAndJourne, _node$eventsAndJourne2, _node$socialSharingDe, _node$heroImage, _node$heroImage$file, _node$mobileHeroImage, _node$mobileHeroImage2, _node$indexImage$file, _node$heroImage2, _node$heroImage2$file, _node$mobileHeroImage3, _node$mobileHeroImage4;
        var node = _ref5.node;
        return !!node && /*#__PURE__*/ react_1.default.createElement(molecules_1.ArticleTeaser, {
            key: node.slug,
            title: (_node$title2 = node.title) === null || _node$title2 === void 0 ? void 0 : _node$title2.title,
            eyebrowLabel: !!node.eventDate ? node.duration + " | " + node.eventDate : (_node$eventsAndJourne = node.eventsAndJourneysCategories) === null || _node$eventsAndJourne === void 0 ? void 0 : (_node$eventsAndJourne2 = _node$eventsAndJourne[0]) === null || _node$eventsAndJourne2 === void 0 ? void 0 : _node$eventsAndJourne2.name,
            description: (_node$socialSharingDe = node.socialSharingDescription) === null || _node$socialSharingDe === void 0 ? void 0 : _node$socialSharingDe.socialSharingDescription,
            url: "/experiences/" + node.slug,
            floatingImageUrl: ((_node$heroImage = node.heroImage) === null || _node$heroImage === void 0 ? void 0 : (_node$heroImage$file = _node$heroImage.file) === null || _node$heroImage$file === void 0 ? void 0 : _node$heroImage$file.url) || ((_node$mobileHeroImage = node.mobileHeroImage) === null || _node$mobileHeroImage === void 0 ? void 0 : (_node$mobileHeroImage2 = _node$mobileHeroImage.file) === null || _node$mobileHeroImage2 === void 0 ? void 0 : _node$mobileHeroImage2.url),
            heroImageUrl: node.indexImage ? (_node$indexImage$file = node.indexImage.file) === null || _node$indexImage$file === void 0 ? void 0 : _node$indexImage$file.url : (_node$heroImage2 = node.heroImage) === null || _node$heroImage2 === void 0 ? void 0 : (_node$heroImage2$file = _node$heroImage2.file) === null || _node$heroImage2$file === void 0 ? void 0 : _node$heroImage2$file.url,
            mobileHeroImageUrl: (_node$mobileHeroImage3 = node.mobileHeroImage) === null || _node$mobileHeroImage3 === void 0 ? void 0 : (_node$mobileHeroImage4 = _node$mobileHeroImage3.file) === null || _node$mobileHeroImage4 === void 0 ? void 0 : _node$mobileHeroImage4.url,
            layout: calcTeaserLayout(index),
            orientation: index % 2 ? 'right' : 'left'
        });
    })), /*#__PURE__*/ react_1.default.createElement(atoms_1.Button, {
        to: "/experiences",
        type: "outline",
        lines: true,
        center: true,
        size: "large"
    }, "More Experiences"), /*#__PURE__*/ react_1.default.createElement(molecules_1.RegisterInLayout, null), /*#__PURE__*/ react_1.default.createElement(organisms_1.HomepageHero, null));
}; // Styling
// Note: this template shares a lot in common with ./destination.tsx
// If this component has much styling, may make sense to share it.
var Article = styled_components_1.default.article.withConfig({
    displayName: "experience__Article",
    componentId: "sc-1p3hk9u-0"
})([""]);
var TeaserList = styled_components_1.default.section.withConfig({
    displayName: "experience__TeaserList",
    componentId: "sc-1p3hk9u-1"
})([""]); // Data
exports.pageQuery = "3895195655"; // Typing
// Helper
exports.convertPillarsToItems = function convertPillarsToItems(_ref6) {
    var priorPillars = _ref6.priorPillars;
    if (!priorPillars)
        return [];
    return priorPillars === null || priorPillars === void 0 ? void 0 : priorPillars.map(function (pillar) {
        var _thumbnail, _thumbnail$file, _description, _description$childMar;
        return {
            title: pillar.title || "",
            image: (_thumbnail = pillar.thumbnail) === null || _thumbnail === void 0 ? void 0 : (_thumbnail$file = _thumbnail.file) === null || _thumbnail$file === void 0 ? void 0 : _thumbnail$file.url,
            caption: ((_description = pillar.description) === null || _description === void 0 ? void 0 : (_description$childMar = _description.childMarkdownRemark) === null || _description$childMar === void 0 ? void 0 : _description$childMar.html) || undefined
        };
    });
};
var mapDataToProps = function mapDataToProps(_ref7) {
    var contentfulEventsAndJourneys = _ref7.contentfulEventsAndJourneys, allContentfulEventsAndJourneysCategory = _ref7.allContentfulEventsAndJourneysCategory, allContentfulEventsAndJourneys = _ref7.allContentfulEventsAndJourneys;
    return Object.assign({}, contentfulEventsAndJourneys, {
        allContentfulEventsAndJourneysCategory: allContentfulEventsAndJourneysCategory,
        allContentfulEventsAndJourneys: allContentfulEventsAndJourneys
    });
};
exports.default = _utils_1.WithData(mapDataToProps, ExperienceTemplate);
